import { View, type ViewProps } from 'react-native';

import { BOUNDED } from './bounds';
import { cn } from './cn';

/**
 * Applies the global page-width cap to static, non-scrolling content — fixed
 * bars (NavBar/top bar/footer), centered form columns, popovers. For scrolling
 * content use `<BoundedScrollView>` instead so the scroll surface stays
 * full-width. No-op on phones (always narrower than the cap).
 */
export function Bounded({ children, className, ...props }: ViewProps) {
  return (
    <View className={cn(BOUNDED, className)} {...props}>
      {children}
    </View>
  );
}
